import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/**
 * Records a warehouse-flagged problem against an order or a return, with
 * optional line-item granularity on either side.
 */
export const flagWarehouseProblem = {
  name: "flagWarehouseProblem" as const,
  input: z.object({
    target: z.discriminatedUnion("kind", [
      z.object({
        kind: z.literal("return"),
        returnId: zExt.objectId("returns"),
        returnItemId: zExt.objectId().optional(),
      }),
      z.object({
        kind: z.literal("order"),
        orderId: zExt.objectId("orders"),
        /** Platform (Shopify) line item id within the order. */
        lineItemId: z.string().optional(),
      }),
    ]),
    note: z.string().trim().min(1),
  }),
  output: z.object({ id: z.string() }),
};
